import { render, staticRenderFns } from "./ProductListUnitsTableDetail.vue?vue&type=template&id=57c301b9&"
import script from "./ProductListUnitsTableDetail.vue?vue&type=script&lang=ts&"
export * from "./ProductListUnitsTableDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports